var React = require('react');

function MenuHamburger (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.5 10H17.5","stroke":"#121314","strokeWidth":"1.66667","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2.5 5H17.5","stroke":"#121314","strokeWidth":"1.66667","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M2.5 15H17.5","stroke":"#121314","strokeWidth":"1.66667","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

MenuHamburger.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = MenuHamburger;

MenuHamburger.default = MenuHamburger;
